import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/home";

Vue.use(Router);

export const routerMap = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/about")
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("@/views/contact")
  },
  {
    path: "/smartExecution",
    name: "assistant",
    component: () => import("@/views/assistant")
  },
  {
    path: "/smartAnalytics",
    name: "investment",
    component: () => import("@/views/investment")
  },
  {
    path: "/industrialChain",
    name: "industrialChain",
    component: () => import("@/views/industrialChain")
  },
  {
    path: "/transactionSupervision",
    name: "transactionSupervision",
    component: () => import("@/views/transactionSupervision")
  },
  {
    path: "/eduAndResearch",
    name: "eduAndResearch",
    component: () => import("@/views/eduAndResearch")
  },
  {
    path: "/aboutHonor",
    name: "aboutHonor",
    component: () => import("@/views/aboutHonor")
  },
  {
    path: "/businessCase",
    name: "businessCase",
    component: () => import("@/views/businessCase")
  },
  {
    path: "/aboutHistory",
    name: "aboutHistory",
    component: () => import("@/views/aboutHistory")
  }
];

export default new Router({
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  routes: routerMap
});



// WEBPACK FOOTER //
// ./src/router/index.js